import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import Tile from '../../App/styledComponents/Tile';

export default InjectedStyledComponent(Tile, 'userDetail', ['wrapper']);